module.exports = __webpack_public_path__ + "img/Rack.7823619b.png";